@if (contact) {
  <div class="contact-rows contact-rows--{{ cardType }}">
    @for (field of contactFields; track field.key) {
      @if (contact[field.key]) {
        <div class="contact-rows__row contact-rows__row--{{ field.variant }}">
          <mat-icon class="contact-rows__row--icon" fontSet="material-icons-outlined">{{ field.icon }}</mat-icon>
          @if (field.showLabel) {
            <span class="contact-rows__row--label">{{ field.label }}</span>
          }
          <span class="contact-rows__row--value">{{ contact[field.key] }}</span>
        </div>
      }
    }
  </div>
}
